import { render } from "./GalleryItemImages.vue?vue&type=template&id=a06af1e6&scoped=true"
import script from "./GalleryItemImages.vue?vue&type=script&lang=js"
export * from "./GalleryItemImages.vue?vue&type=script&lang=js"

import "./GalleryItemImages.vue?vue&type=style&index=0&id=a06af1e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06af1e6"]])

export default __exports__